// extracted by mini-css-extract-plugin
module.exports = {"qsConfirmAntdModal":"_39tBj","qsBasicAntdModal":"_2A9FQ","modalOkBtn":"_2_mbG","modalCancelBtn":"_2-mRH","mobileQsBasicAntdModal":"_4kl4N"};